























































































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import SubmitTestTable from '../organisms/SubmitTestTable.vue'
import SubmitTableSp from '../organisms/SubmitTestTableSP.vue'
import SubmitFlow from '../organisms/SubmitFlow.vue'
import WebSubmitNote from '../organisms/WebSubmitNote.vue'
import { TestInfo } from '../../utils/service/KoushiSite'
import axios from 'axios'

interface Stepp {
  text: string,
  current: boolean,
}

export type DataType = {
  titleName: string
  testInfo: TestInfo[]
  width: number | null
  stepps: Stepp[]
}


export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    SubmitTestTable,
    SubmitTableSp,
    SubmitFlow,
    WebSubmitNote
  },
  data(): DataType {
    return {
      titleName: 'テスト提出と結果',
      testInfo: [],
      width: null,
      stepps: [
        { text: 'メールアドレスの登録', current: false },
        { text: 'テスト提出サイトにログイン', current: false },
        { text: 'カメラで撮影して提出', current: true },
      ]
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    // サーバ側の現在時刻を取得
    this.$store.dispatch('getCurrentDate')

    // テストの情報を取得する APIを叩く
    this.testInfo = []
    const res = await axios.get('/api/v1/submit/tests')
    this.testInfo = res.data?.datas
  },
  watch: {
    "$route.hash"(newValue) {
      if(!newValue) return
      this.$nextTick(() => {
        this.scrollToSubmitFlow()
      })
    }
  },
  computed: {
    isSP(): boolean {
      // width がnullだったらSP判定でfalseを返す
      return (this.width || 769) <= 768
    },
    isShowQuestionnaire(): boolean {
      // 開発環境では表示
      if (process.env.NODE_ENV === 'development') return true
      // 表示期間：2021/08/6 13:00 〜 2021/11/30 23:59
      const today = new Date(this.$store.state.currentDate)
      return new Date(this.$store.state.examInfo.enqueteStart) <= today && today <= new Date(this.$store.state.examInfo.enqueteEnd)
    },
    contactPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/contact/form/`
    },
    envPageUrl(): string {
      return '/tensaku_visiter/device/'
    }
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    submit(testInfo: TestInfo) {
      this.$store.commit('SET_SUBMITTING_TEST_INFO', testInfo)
      this.$router.push('/tensaku_visiter/submit')
    },
    scrollToSubmitFlow(): void {
      const ref: any = this.$refs['submit-flow']
      ref.$el.scrollIntoView({ behavior: 'smooth' })
    },
  },
})
